// 获取系统CPU和内存信息的hooks
import { ref, onUnmounted } from 'vue';

export function useSystemInfo(options = { interval: 1000 }) {
  const cpuUsage = ref(0);
  const memoryInfo = ref({
    total: 0,
    used: 0,
    free: 0,
    usage: 0
  });
  
  let timer = null;
  const { interval } = options;

  // 检查是否在Electron环境中
  const isElectron = () => {
    return typeof window !== 'undefined' && 
           typeof window.require === 'function' &&
           window.require('electron');
  };

  const getSystemInfo = async () => {
    try {
      if (isElectron()) {
        // Electron环境：通过IPC获取系统信息
        const electron = window.require('electron');
        const result = await electron.ipcRenderer.invoke('get-system-info');
        if (result) {
          cpuUsage.value = parseFloat(result.cpu);
          memoryInfo.value = result.memory;
        }
      } else {
        // 浏览器环境：使用performance.memory（仅Chrome支持）模拟内存信息
        if (performance.memory) {
          const mem = performance.memory;
          memoryInfo.value = {
            total: (mem.jsHeapSizeLimit / 1024 / 1024).toFixed(2),
            used: (mem.usedJSHeapSize / 1024 / 1024).toFixed(2),
            free: ((mem.jsHeapSizeLimit - mem.usedJSHeapSize) / 1024 / 1024).toFixed(2),
            usage: ((mem.usedJSHeapSize / mem.jsHeapSizeLimit) * 100).toFixed(1)
          };
        }
        // 浏览器环境无法获取真实CPU使用率，使用模拟数据
        cpuUsage.value = Math.floor(Math.random() * 30 + 10);
      }
    } catch (error) {
      console.error('获取系统信息失败:', error);
      // 发生错误时使用模拟数据
      cpuUsage.value = Math.floor(Math.random() * 30 + 10);
      memoryInfo.value = {
        total: '16.00',
        used: (Math.random() * 8 + 4).toFixed(2),
        free: (Math.random() * 4 + 2).toFixed(2),
        usage: Math.floor(Math.random() * 50 + 30)
      };
    }
  };

  // 启动定时获取
  const start = () => {
    getSystemInfo();
    timer = setInterval(getSystemInfo, interval);
  };

  // 停止获取
  const stop = () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  };

  // 自动启动
  start();

  // 组件卸载时自动清理
  onUnmounted(() => {
    stop();
  });

  return {
    cpuUsage,
    memoryInfo,
    start,
    stop
  };
}